import {
  Box,
  Center,
  Text,
  Link,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import SectionHeading from "./sectionHeading";
import Lang from "../../Lang";

export default function Apply() {
  return (
    <>
      <LineSection />
      <Box
        color='white'
      >

        <Center>
          <Box
            w={{ base: "full", md: "4xl", xl: "7xl" }}
          >
            <Box
              pt={20}
            >

              <SectionHeading
                title="Apply"
              />
              <Text
                pb={{base:40,md:60}}
                px={{ base: 4, md: 6 }}
                fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
              >
                <Lang text="If you are a business owner that meets the aforementioned requirements and wishes to avail our free support to optimize any aspect of your business model, do not hesitate to submit your application through" /> &nbsp;
                <Link
                  href="/apply"
                  className="barlow-black"
                >
                  <Text as={'span'} color={"#4aeade"}>
                    <Lang text="HOW TO APPLY"/>
                  </Text>
                </Link>.

              </Text>
            </Box>
          </Box>
        </Center>
      </Box>
    </>
  );
}